import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import CurrencyFormatter from "currency-formatter";
import {FormattedMessage} from "react-intl";
import {Button, ButtonGroup, FormHelperText, Grid, withStyles} from "@material-ui/core";
import MoneyInputField from "./MoneyInputField";

const styles = (theme) => ({
  container: {
  },
  customAmountContainer: {
    marginTop: -8,
    position: 'relative',
    width: '100%',
    display: 'inline-block'
  },
  presetBalanceButton: {
    minWidth: 0,
    flexGrow: 1
  }
});

CardAmountField.propTypes = {
  amount: PropTypes.number.isRequired,
  currency: PropTypes.object.isRequired,
  presetBalances: PropTypes.array.isRequired,
  locale: PropTypes.object.isRequired,
  errorText: PropTypes.string,
  customAmountAllowed: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.object
};

function CardAmountField({
                           amount,
                           currency,
                           presetBalances,
                           locale,
                           errorText,
                           customAmountAllowed = true,
                           onChange,
                           classes
                         }) {

  const [customAmountSelected, setCustomAmountSelected] = useState(false);

  useEffect(() => {
    setCustomAmountSelected(determineCustomAmountSelected);
  }, [amount]);

  function determineCustomAmountSelected() {
    return presetBalances && presetBalances.length > 0 && !presetBalances.includes(amount);
  }

  function handleAmountChange(value) {
    if (value && value > 0) {
      onChange(value);
    }

  }

  function handleOnPresetBalanceClick(amount) {
    setCustomAmountSelected(false);
    onChange(amount);
  }

  function handleOnCustomAmountClick() {
    setCustomAmountSelected(true);
  }

  function renderPresetBalance(presetAmount) {
    if (presetAmount === 0) {
      return;
    }

    const isSelected = presetAmount === amount && !customAmountSelected;
    const adjustedAmount = presetAmount / Math.pow(10, currency.decimalDigits);
    const formattedAmount = CurrencyFormatter.format(adjustedAmount, {locale, code: currency.code, precision: 0, format: '%s%v'});

    return (
      <Button
        variant={isSelected ? 'contained' : 'outlined'}
        fullWidth={false}
        color={isSelected ? 'secondary' : 'default'}
        onClick={() => handleOnPresetBalanceClick(presetAmount)}
        key={'amount-' + adjustedAmount}
        data-test={'button-preset-amount-' + presetAmount}
        className={classes.presetBalanceButton}
      >
        {formattedAmount}
      </Button>
    );
  }

  const showPresetBalances = presetBalances && presetBalances.length > 0;
  const showCustomAmount = (!showPresetBalances || customAmountSelected) && customAmountAllowed;
  return (
    <Grid container spacing={2} className={classes.container}>
      {showPresetBalances &&
      <Grid item xs={12}>
        <ButtonGroup color="primary" style={{width: '100%'}}>
          {presetBalances.map((amount, index) => {
            return renderPresetBalance(amount);
          })}
          {customAmountAllowed &&
            <Button
              variant={customAmountSelected ? 'contained' : 'outlined'}
              fullWidth={false}
              color={customAmountSelected ? 'secondary' : 'default'}
              onClick={handleOnCustomAmountClick}
              className={classes.presetBalanceButton}
              data-test={'button-preset-amount-custom'}
            >
              <FormattedMessage id={"button.custom-amount"}/>
            </Button>
          }
        </ButtonGroup>
        {errorText && !showCustomAmount &&
          <FormHelperText error={true}>
            {errorText}
          </FormHelperText>
        }
      </Grid>
      }
      {showCustomAmount &&
      <Grid item xs={12}>
        <MoneyInputField
          value={amount}
          currency={currency}
          onValueChange={handleAmountChange}
          error={!!errorText}
          helperText={errorText}
          label={<FormattedMessage id={'form.custom-amount'}/>}
          fullWidth
          variant={'outlined'}
        />
      </Grid>
      }
    </Grid>
  );
}

export default withStyles(styles)(CardAmountField);
